export default {
  'supportChat.title': 'Please write your message',
  'supportChat.subTitle': 'Agents are online!',
  'supportChat.button': 'Online support - We are very close to you!',
  'supportChat.placeholder': 'Write your message...',
  'supportChat.you': 'You',
  'supportChat.voiceMessage': 'Voice message',
  'supportChat.audioNotAvailable': 'Audio not available for playback',
  'supportChat.copy': 'Copy',
  'supportChat.copied': 'Copied!',
  'supportChat.codeCopied': 'Code copied to clipboard',
  'supportChat.copyError': 'Error copying code',
  'supportChat.attachedFile': 'Attached file',
  'supportChat.recording': 'Recording',
  'supportChat.browserNotSupported': 'Your browser does not support the audio element.',
  'supportChat.send': 'Send message',
  'supportChat.attachment': 'Add attachment',
  'supportChat.fileUpload': 'Upload file',
  'supportChat.recordAudio': 'Record audio',
  'supportChat.startRecording': 'Start recording',
  'supportChat.stopRecording': 'Stop recording',
  'supportChat.addUrl': 'Add URL',
  'supportChat.newChat': 'New Chat',
  'supportChat.close': 'Close chat',
  'supportChat.errorSending': 'Error sending message',
  'supportChat.removeAttachment': 'Remove attachment',
  'supportChat.enterUrl': 'Enter URL',
  'supportChat.stop': 'Stop',
  'supportChat.preview': 'Preview',
  'supportChat.errorUploadingFile': 'Error uploading file',
  'supportChat.errorProcessingFile': 'Error processing file',
  'supportChat.headerTitle': 'AUTOMY Assistant',
  'supportChat.headerSubtitle': 'Your agent for automation and data.',
  'supportChat.welcome':
    '👋 Hi! I am your AUTOMY AI Assistant.\nI am here to help you with:\n\n• Solving questions 🤔\n• Automating processes ⚙️\n• Analyzing your data 📊\n• Executing functions in real time 🚀\n\nHow can I help you today?',
  'supportChat.placeholder.inspire': 'Ask me a question or request an action from the assistant...',
  'supportChat.placeholder.inspireMobile': 'Ask or request an action...',
  'supportChat.placeholder.aiThinking': 'AI is thinking, please wait...',
  'supportChat.aiThinkingBlocked': 'Please wait while the AI is processing your previous message.',
  'supportChat.aiWarning': '⚡ AI-generated responses. Always verify.',
  'supportChat.hideChat': 'Hide Chat',
  'supportChat.voiceMessageFileName': 'voice_message.webm',
  'supportChat.invalidUrl': 'The provided URL is not valid.',
  'supportChat.cannotAccessResource': 'Could not access the resource at the provided URL.',
  'supportChat.cannotDetermineContentType': 'Could not determine the content type of the resource.',
  'supportChat.invalidContentType': 'The content type is not valid.',
  'supportChat.errorGettingContentType': 'An error occurred while trying to get the content type.',
  'supportChat.fileTypeNotAllowed': 'File type not allowed. Only images and audio are allowed.',
  'supportChat.button.full': 'Need help? Ask the AI ​​Assistant',
  'supportChat.loadingMoreMessages': 'Loading previous messages...',
  'supportChat.loadingAgents': 'Loading agents...',
  'supportChat.loadMoreAgents': 'Load more agents...',
  'supportChat.searchAgents': 'Search agents...',
  'supportChat.noAgentsFound': 'No agents found',
  'supportChat.status.pending': 'Pending',
  'supportChat.status.active': 'Active',
  'supportChat.status.lookingForAgent': 'Looking for agent',
  'supportChat.status.closed': 'Closed',
  'supportChat.status.archived': 'Archived',
  'supportChat.messageStatus.policyViolation': 'Blocked by moderation',
  'supportChat.messageStatus.failed': 'Message failed',
  'supportChat.messageStatus.error': 'Message error',
  'supportChat.messageError.title': 'Message could not be delivered',
  'supportChat.messageError.subtitle': 'Error details',
  'supportChat.moderation.title': 'Message blocked by moderation',
  'supportChat.moderation.defaultUserMessage':
    'This message was not processed because it violates our usage policies.',
  'supportChat.moderation.severityLabel': 'Severity:',
  'supportChat.moderation.severity.hardBlock': 'Critical block',
  'supportChat.moderation.severity.softBlock': 'Partial block',
  'supportChat.moderation.severity.flagged': 'Flagged for review',
  'supportChat.moderation.severity.unknown': 'Unknown severity',
  'supportChat.moderation.categoriesLabel': 'Detected categories:',
  'supportChat.moderation.categoryFallback': '{category}',
  'supportChat.moderation.categories.illicit': 'Illicit content',
  'supportChat.moderation.categories.illicitViolent': 'Illicit violent content',
  'supportChat.moderation.categories.hate': 'Hate speech',
  'supportChat.moderation.categories.hateThreatening': 'Hate threatening',
  'supportChat.moderation.categories.harassment': 'Harassment',
  'supportChat.moderation.categories.sexual': 'Sexual content',
  'supportChat.moderation.categories.sexualMinors': 'Sexual content involving minors',
  'supportChat.moderation.categories.selfHarm': 'Self-harm',
  'supportChat.moderation.categories.violence': 'Violence',
  'supportChat.moderation.categories.violenceGraphic': 'Graphic violence',
  'supportChat.guardrails.urlFilter.title': 'URL filtering',
  'supportChat.guardrails.urlFilter.blockedTitle': 'Message blocked by URL filtering',
  'supportChat.guardrails.urlFilter.label': 'URL filter',
  'supportChat.guardrails.urlFilter.action.block': 'URL blocked',
  'supportChat.guardrails.urlFilter.action.mask': 'URL masked',
  'supportChat.guardrails.urlFilter.action.allow': 'URL allowed',
  'supportChat.guardrails.urlFilter.action.unknown': 'URL filter applied',
  'supportChat.guardrails.jailbreak.title': 'Jailbreak / prompt injection',
  'supportChat.guardrails.jailbreak.badge': 'Jailbreak detected',
  'supportChat.guardrails.jailbreak.label': 'Jailbreak',
  'supportChat.guardrails.moderation': 'Moderation',
  'supportChat.guardrails.title': 'Guardrails',
  'supportChat.guardrails.status': 'Guardrails',
  'supportChat.guardrails.jailbreak.detected': 'Jailbreak detected',
  'supportChat.guardrails.jailbreak.notDetected': 'No jailbreak detected',
  'supportChat.guardrails.promptInjection.detected': 'Prompt injection detected',
  'supportChat.guardrails.promptInjection.notDetected': 'No prompt injection detected',
  'supportChat.deleteThreadTitle': 'Delete this conversation? This action is irreversible.',
  'supportChat.deleteThreadContent': 'This action cannot be undone.',
  'supportChat.deleteThreadOk': 'Delete',
  'supportChat.deleteThreadCancel': 'Cancel',
  'supportChat.closedChatPlaceholder':
    'This conversation is closed or archived. To continue, please reopen it first.',
  'supportChat.closedButAgentWorking':
    'This conversation is closed, but the agent is still processing in the background.',
  'supportChat.reopenChat': 'Reopen',
  'supportChat.chatReopened': 'Chat reopened successfully',
  'supportChat.closeThreadTitle':
    'Do you want to close this conversation? You can reopen it later.',
  'supportChat.closeThreadOk': 'Close',
  'supportChat.closeThreadCancel': 'Cancel',
  'supportChat.errorCreatingNewChat': 'Error creating new chat',
  'supportChat.showThreads': 'View conversations',
  'supportChat.yesterday': 'Yesterday',
  'supportChat.today': 'Today',
  'supportChat.loadingMoreThreads': 'Loading more conversations...',
  'supportChat.noMoreThreads': 'No more conversations',
  'supportChat.errorUploadingAttachment': 'Error uploading file',
  'supportChat.errorSendingMessage': 'Error sending message',
  'supportChat.errorReopeningChat': 'Error reopening chat',
  'supportChat.button.header': '✨ AI Assistant',
  'supportChat.fullscreen': 'Fullscreen',
  'supportChat.noThreads': 'No conversations yet',
  'supportChat.thisWeek': 'This week',
  'supportChat.lastMonth': 'Last month',
  'supportChat.older': 'Older',
  'supportChat.connectionReestablished': 'Connection reestablished',
  'supportChat.connectionReestablishedWithIssue':
    'Connection reestablished but there was a problem joining the chat',
  'supportChat.connectionLost': 'Connection lost. Retrying automatically...',
  'supportChat.errorSendingMessageGeneric': 'Error sending message',
  'supportChat.noConnectionQueueMessage': 'You are offline. Connect to send the message.',
  'supportChat.noActiveThread': 'No active conversation',
  'supportChat.cannotSendToClosedThread':
    'Cannot send messages to a closed or archived conversation',
  'supportChat.socketNotAvailable': 'Service not available',
  'supportChat.pendingMessagesSent': 'message(s) sent successfully',
  'supportChat.thinking': 'Thinking',
  'supportChat.executing': 'Executing',
  'supportChat.newMessages': 'new',
  'supportChat.newMessagesPlural': 'new',
  'supportChat.uploading': 'Uploading',
  'supportChat.cancelUpload': 'Cancel upload',
  'supportChat.cleaningFile': 'Cleaning file...',

  // Tooltips for conversation buttons
  'supportChat.editThread': 'Edit',
  'supportChat.closeThread': 'Close',
  'supportChat.deleteThread': 'Delete',

  // Keys for scheduled tasks
  'supportChat.showTasks': 'View tasks',
  'supportChat.showEmails': 'Emails',
  'supportChat.noEmails': 'No emails for this thread yet',
  'supportChat.loadingEmails': 'Loading emails...',
  'supportChat.emailFrom': 'From',
  'supportChat.emailTo': 'To',
  'supportChat.emailResponse.success': 'Delivered',
  'supportChat.backToChat': 'Back to chat',
  'supportChat.noTasks': 'No scheduled tasks yet',
  'supportChat.loadingMoreTasks': 'Loading more tasks...',
  'supportChat.noMoreTasks': 'No more tasks',
  'supportChat.executeTask': 'Execute Task',
  'supportChat.pauseTask': 'Pause Task',
  'supportChat.resumeTask': 'Resume Task',
  'supportChat.taskHistory': 'History',
  'supportChat.deleteTask': 'Delete Task',
  'supportChat.taskExecuted': 'Task executed successfully',
  'supportChat.taskPaused': 'Task paused',
  'supportChat.taskResumed': 'Task resumed',
  'supportChat.taskDeleted': 'Task deleted',
  'supportChat.deleteTaskTitle': 'Delete this task? This action is irreversible.',
  'supportChat.deleteTaskOk': 'Delete',
  'supportChat.deleteTaskCancel': 'Cancel',
  'supportChat.taskStatus.pending': 'Pending',
  'supportChat.taskStatus.processing': 'Processing',
  'supportChat.taskStatus.processed': 'Processed',
  'supportChat.taskStatus.error': 'Error',
  'supportChat.taskStatus.skipped': 'Skipped',
  'supportChat.taskStatus.cancelled': 'Cancelled',
  'supportChat.taskStatus.failed': 'Failed',
  'supportChat.scheduledFor': 'Scheduled for',
  'supportChat.repeatEvery': 'Repeats every',
  'supportChat.maxOccurrences': 'Maximum executions',
  'supportChat.unlimited': 'Unlimited',
  'supportChat.errorExecutingTask': 'Error executing task',
  'supportChat.errorPausingTask': 'Error pausing task',
  'supportChat.errorResumingTask': 'Error resuming task',
  'supportChat.errorDeletingTask': 'Error deleting task',
  'supportChat.taskFrequency.minute': 'minute(s)',
  'supportChat.taskFrequency.hour': 'hour(s)',
  'supportChat.taskFrequency.day': 'day(s)',
  'supportChat.taskFrequency.week': 'week(s)',
  'supportChat.taskFrequency.month': 'month(s)',

  // Task frequency variations
  'supportChat.taskFrequency.daily': 'days',
  'supportChat.taskFrequency.weekly': 'weeks',
  'supportChat.taskFrequency.monthly': 'months',
  'supportChat.taskFrequency.yearly': 'years',
  'supportChat.taskFrequency.minutes': 'minutes',
  'supportChat.taskFrequency.hours': 'hours',

  // Task actions
  'supportChat.viewTaskRuns': 'View execution history',

  // Task execution results
  'supportChat.taskExecuted': 'Task executed successfully',
  'supportChat.taskPaused': 'Task paused successfully',
  'supportChat.taskResumed': 'Task resumed successfully',
  'supportChat.taskDeleted': 'Task deleted successfully',

  // Task error messages
  'supportChat.errorExecutingTask': 'Error executing task',
  'supportChat.errorPausingTask': 'Error pausing task',
  'supportChat.errorResumingTask': 'Error resuming task',
  'supportChat.errorDeletingTask': 'Error deleting task',

  // Task deletion dialog
  'supportChat.deleteTaskTitle': 'Delete task?',
  'supportChat.deleteTaskOk': 'Delete',
  'supportChat.deleteTaskCancel': 'Cancel',

  // Task parameters
  'supportChat.repeatEvery': 'Repeat every',
  'supportChat.maxOccurrences': 'Maximum executions',
  'supportChat.unlimited': 'Unlimited',

  // Task list states
  'supportChat.noTasks': 'No scheduled tasks',
  'supportChat.loadingMoreTasks': 'Loading more tasks...',
  'supportChat.noMoreTasks': 'No more tasks to show',

  // Task runs history
  'supportChat.taskRuns': 'Execution History',
  'supportChat.backToTasks': 'Back to Tasks',
  'supportChat.taskRunsFor': 'Execution history for',
  'supportChat.noRuns': 'No executions for this task',
  'supportChat.loadingMoreRuns': 'Loading more runs...',
  'supportChat.noMoreRuns': 'No more executions to show',

  // Run status
  'supportChat.runStatus.pending': 'Pending',
  'supportChat.runStatus.processing': 'Processing',
  'supportChat.runStatus.processed': 'Processed',
  'supportChat.runStatus.error': 'Error',
  'supportChat.runStatus.skipped': 'Skipped',
  'supportChat.runStatus.cancelled': 'Cancelled',
  'supportChat.runStatus.failed': 'Failed',
  'supportChat.runStatus.unknown': 'Unknown',

  // Run details
  'supportChat.duration': 'Duration',
  'supportChat.output': 'Output',

  // New content types
  'supportChat.taskExecution': 'Task Execution',
  'supportChat.viewDetails': 'View Details',
  'supportChat.hideDetails': 'Hide',
  'supportChat.audioFromUrl': 'Audio from URL',
  'supportChat.documentFromUrl': 'Document from URL',
  'supportChat.imageFromUrl': 'Image from URL',
  'supportChat.image': 'Image',
  'supportChat.openInMaps': 'Open in Google Maps',
  'supportChat.location': 'Location',
  'supportChat.phone': 'Phone',
  'supportChat.email': 'Email',

  // Multi-agent support
  'supportChat.loadingAgents': 'Loading agents...',
  'supportChat.selectAgent': 'Select agent',

  // Copy and export message options
  'supportChat.copyMessage': 'Copy message',
  'supportChat.exportMessage': 'Export message',
  'supportChat.export': 'Export',
  'supportChat.reply': 'Reply',
  'supportChat.replyMessage': 'Reply to this message',
  'supportChat.replyingTo': 'Replying to',
  'supportChat.inReplyTo': 'In reply to',
  'supportChat.messagePreviewNotAvailable': 'Preview not available',
  'supportChat.messageContent': 'Message content',
  'supportChat.clickToGoToMessage': 'Click to go to original message',
  'supportChat.cancelReply': 'Cancel reply',
  'supportChat.you': 'You',
  'supportChat.automy': 'AUTOMY',
  'supportChat.messageCopied': 'Message copied to clipboard',
  'supportChat.messageExported': 'Message exported successfully',
  'supportChat.copyError': 'Error copying message',
  'supportChat.exportError': 'Error exporting message',

  // Human agent events
  'supportChat.humanAgentAssigned': 'A human agent has been assigned to your chat.',
  'supportChat.humanAgentAssignedWithName': 'Agent {name} has been assigned to your chat.',
  'supportChat.transferToHuman': 'Transfer to support',
  'supportChat.transferToAI': 'Transfer to AI',
  'supportChat.transferToAI.error': 'Failed to transfer chat to AI',
  'supportChat.transferToHuman.error': 'Failed to transfer chat to support',
  'supportChat.contacts': 'Contacts',
  'supportChat.contacts.loadError': 'Error loading contacts',
  'supportChat.noContacts': 'No contacts found for this thread',
  'supportChat.contact.edit': 'Edit contact',
  'supportChat.contact.delete': 'Delete contact',
  'supportChat.contact.deleteTitle': 'Remove contact',
  'supportChat.contact.deleteContent': 'Are you sure you want to remove {name} from this thread?',
  'supportChat.contact.deleteSuccess': 'Contact removed successfully',
  'supportChat.contact.deleteError': 'Error removing contact',
  'supportChat.contact.updateSuccess': 'Contact updated successfully',
  'supportChat.contact.updateError': 'Error updating contact',
  'supportChat.contact.noChanges': 'There are no changes to save',
  'supportChat.contact.noEditableFields': 'This contact does not have editable fields',
  'supportChat.contact.unnamed': 'Unnamed contact',
  'supportChat.contact.field.fullName': 'Full name',
  'supportChat.contact.field.name': 'Name',
  'supportChat.contact.field.email': 'Email',
  'supportChat.contact.field.phone': 'Phone',
  'supportChat.contact.field.phoneNumber': 'Phone number',
  'supportChat.contact.field.mobilePhone': 'Mobile phone',
  'supportChat.contact.field.company': 'Company',
  'supportChat.contact.field.position': 'Position',
  'supportChat.contact.field.notes': 'Notes',
  'supportChat.contact.field.generic': '{field}',
  'supportChat.loadingMoreContacts': 'Loading more contacts...',
  'supportChat.contact.noDetails': 'No additional details available',
  'supportChat.edit': 'Edit',
  'supportChat.delete': 'Delete',
  'supportChat.notAvailable': 'N/A',
  'supportChat.contact.editDrawer.subtitle': 'Edit contact',
  'supportChat.contact.editDrawer.sectionTitle': 'Contact details',
  'supportChat.contact.editTitleFallback': 'Contact',
  'supportChat.loadingParticipants': 'Loading participants...',
  'supportChat.threadInfo.tab': 'Thread info',
  'supportChat.threadInfo.noThreadSelected': 'Select a thread to see its details.',
  'supportChat.threadInfo.basicSection': 'Basic details',
  'supportChat.threadInfo.number': 'Case number',
  'supportChat.threadInfo.threadId': 'Thread ID',
  'supportChat.threadInfo.status': 'Status',
  'supportChat.threadInfo.type': 'Type',
  'supportChat.threadInfo.handler': 'Handler',
  'supportChat.threadInfo.controlMode': 'Control mode',
  'supportChat.threadInfo.accessMode': 'Access',
  'supportChat.threadInfo.channelId': 'Channel ID',
  'supportChat.threadInfo.agentId': 'Agent ID',
  'supportChat.threadInfo.ownerUserId': 'Owner user ID',
  'supportChat.threadInfo.created': 'Created at',
  'supportChat.threadInfo.updated': 'Updated at',
  'supportChat.threadInfo.closed': 'Closed at',
  'supportChat.threadInfo.channelSection': 'Channel data',
  'supportChat.threadInfo.openAIConversation': 'OpenAI conversation ID',
  'supportChat.threadInfo.openAIThreadId': 'OpenAI thread ID',
  'supportChat.threadInfo.openAIConversationCount': 'OpenAI conversations',
  'supportChat.threadInfo.telegramChatId': 'Telegram chat ID',
  'supportChat.threadInfo.telegramBotId': 'Telegram bot ID',
  'supportChat.threadInfo.telegramTopicId': 'Telegram topic ID',
  'supportChat.threadInfo.telegramTopicName': 'Telegram topic name',
  'supportChat.threadInfo.noChannelData': 'No additional channel data available.',
  'supportChat.threadInfo.tokensSection': 'Token consumption',
  'supportChat.threadInfo.tokens.inputTokens': 'Input tokens',
  'supportChat.threadInfo.tokens.cachedTokens': 'Cached tokens',
  'supportChat.threadInfo.tokens.outputTokens': 'Output tokens',
  'supportChat.threadInfo.tokens.reasoningTokens': 'Reasoning tokens',
  'supportChat.threadInfo.tokens.totalTokens': 'Total tokens',
  'supportChat.threadInfo.unknown': 'Unknown',
  'supportChat.threadStatus.pending': 'Pending',
  'supportChat.threadStatus.active': 'Active',
  'supportChat.threadStatus.lookingForAgent': 'Looking for agent',
  'supportChat.threadStatus.closed': 'Closed',
  'supportChat.threadStatus.archived': 'Archived',
  'supportChat.threadType.generalSupport': 'General support',
  'supportChat.threadHandler.none': 'Unassigned',
  'supportChat.threadHandler.ai': 'AI',
  'supportChat.threadHandler.agent': 'Human agent',
  'supportChat.threadControl.auto': 'AI control',
  'supportChat.threadControl.assisted': 'Co-pilot',
  'supportChat.threadControl.humanOnly': 'Human only',
  'supportChat.threadControl.unknown': 'Unknown',
  'supportChat.threadAccess.readOnly': 'Read only',
  'supportChat.threadAccess.write': 'Write',
  'supportChat.showThreadPanel': 'Show info panel',
  'supportChat.hideThreadPanel': 'Hide info panel',
  'supportChat.showRunHistory': 'Show run history',
  'supportChat.hideRunHistory': 'Hide run history',

  // Error messages and missing translations
  'supportChat.connectionTimeout': 'Connection timeout when joining chat',
  'supportChat.socketNotAvailable': 'Socket not available',
  'supportChat.couldNotConnectToJoinChat': 'Could not connect to join chat',
  'supportChat.timeoutJoiningChat': 'Timeout when joining chat',
  'supportChat.errorJoiningChat': 'Error joining chat{separator} {message}',
  'supportChat.unknownError': 'Unknown error',
  'supportChat.scheduledTaskExecution': 'Scheduled task execution',
  'supportChat.loadingConversation': 'Loading conversation...',
  'supportChat.fileUrlNotFound': 'File URL not found. Please try attaching the file again.',
  'supportChat.invalidFileType': 'Invalid file type. Only images and audio files are allowed.',
  'supportChat.uploadCancelled': 'Upload cancelled',
  'supportChat.uploadFailed': 'Upload failed',
  'supportChat.maxAttachments': 'Maximum {max} attachments allowed',
  'supportChat.fileTooLarge': 'File exceeds the maximum size of {max}',
  'supportChat.retryUpload': 'Retry upload',

  // Engine AI instructions
  'supportChat.engineAiMessage.title': 'Engine AI instructions',
  'supportChat.engineAiMessage.empty': 'No instructions available',

  // Email message support
  'supportChat.emailMessage': 'Email Message',
  'supportChat.from': 'From',
  'supportChat.emailFrom': 'From',
  'supportChat.emailTo': 'To',
  'supportChat.emailCc': 'CC',
  'supportChat.collapse': 'Collapse',
  'supportChat.expand': 'Expand',
  'supportChat.noEmailContent': 'No email content available',
  'supportChat.taskDetails': 'Task Details',
  'supportChat.task': 'Task',
  'supportChat.executedAt': 'Executed at {time}',
  'supportChat.executedRecently': 'Executed recently',
  'supportChat.unknown': 'Unknown',
  'supportChat.noOutput': 'No output available',
  'supportChat.runId': 'Run ID',
  'supportChat.noResponseAvailable': 'No response available',

  // Task run detailed information
  'supportChat.runIdComplete': 'Run ID Complete',
  'supportChat.type': 'Type',
  'supportChat.finished': 'Finished',
  'supportChat.status': 'Status',
  'supportChat.lastUpdate': 'Last Update',
  'supportChat.executionNumber': 'Execution Number',
  'supportChat.started': 'Started',
  'supportChat.taskId': 'Task ID',
  'supportChat.processed': 'Processed',
  'supportChat.result': 'Result',
  'supportChat.connectionIssues': 'Connection issues detected - retrying...',
  'supportChat.authenticationExpired': 'Session expired - please reload the page',
  'supportChat.syncing': 'Syncing...',
  'supportChat.syncingThread': 'Syncing thread...',
  'supportChat.reconciliationFailed': 'Could not sync chat state',

  // AI Thinking Operation Messages
  'supportChat.aiThinking.none': 'Processing...',
  'supportChat.aiThinking.analyzingContext': 'Analyzing conversation context...',
  'supportChat.aiThinking.internalReasoning': 'Reasoning internally before responding...',
  'supportChat.aiThinking.toolCalling': 'Executing specialized tools...',
  'supportChat.aiThinking.toolCallingWithFunction': 'Executing: {functionName}',
  'supportChat.aiThinking.toolCompleted': 'Done',
  'supportChat.aiThinking.toolDetail.arguments': 'Arguments',
  'supportChat.aiThinking.toolDetail.output': 'Output',
  'supportChat.aiThinking.toolDetail.error': 'Error',
  'supportChat.aiThinking.idleBetweenSteps': 'Preparing next step...',
  'supportChat.aiThinking.synthesizingAnswer': 'Preparing final response...',
  'supportChat.aiThinking.errorHandling': 'Handling a process error...',
  'supportChat.aiThinking.errorHandlingWithMessage': 'Error: {errorMessage}',
  'supportChat.aiThinking.thinkingThreadTitle': 'Generating conversation title...',
  'supportChat.aiThinking.preparingTaskRun': 'Preparing task execution...',
  'supportChat.aiThinking.downloadingFile': 'Downloading generated file...',
  'supportChat.aiThinking.contextRecovery': 'Recovering conversation context...',
  'supportChat.aiThinking.reasoningOutputCommentary': 'Assistant comment',
  'supportChat.aiThinking.agentCalling': 'Calling an agent...',
  'supportChat.aiThinking.agentCalling.consulting': 'Consulting',
  'supportChat.aiThinking.todoPlanCreated': 'Building action plan...',
  'supportChat.aiThinking.todoItemCreated': 'New task added to the plan',
  'supportChat.aiThinking.todoItemCreatedWithTitle': 'Task added: {title}',
  'supportChat.aiThinking.todoItemCompleted': 'Task completed',
  'supportChat.aiThinking.todoItemCompletedWithTitle': 'Completed: {title}',
  'supportChat.aiThinking.preparingFileResources': 'Preparing file resources...',
  'supportChat.aiThinking.preparingFileResourcesWithCount':
    'Preparing {count, plural, one {# file} other {# files}}...',
  'supportChat.aiThinking.preparingFileResourcesWithNames':
    'Preparing {count, plural, one {# file} other {# files}}: {names}',
  'supportChat.aiThinking.fileUse.label': 'Use: {uses}',
  'supportChat.aiThinking.fileUse.publicUrl': 'Public URL',
  'supportChat.aiThinking.fileUse.modelContext': 'Model context',
  'supportChat.aiThinking.todoPlanTitle': 'Action plan',
  'supportChat.aiThinking.todoCounter': '{completed} of {total}',
  'supportChat.aiThinking.todoHeaderProgress': 'Action plan · {completed}/{total} tasks',
  'supportChat.aiThinking.todoStatus.pending': 'Pending',
  'supportChat.aiThinking.todoStatus.inProgress': 'In progress',
  'supportChat.aiThinking.todoStatus.blocked': 'Blocked',
  'supportChat.aiThinking.todoStatus.onHold': 'On hold',
  'supportChat.aiThinking.todoStatus.completed': 'Completed',
  'supportChat.aiThinking.todoStatus.canceled': 'Canceled',
  'supportChat.aiThinking.todoStatus.failed': 'Failed',

  // AI Thinking Timeline Messages
  'supportChat.aiTimeline.thinking': 'Thinking...',
  'supportChat.aiTimeline.thoughtProcess': 'Thought process',
  'supportChat.aiTimeline.steps': '{count} steps',
  'supportChat.aiTimeline.inProgress': 'in progress',
  'supportChat.aiTimeline.detail': 'View detail',
  'supportChat.aiTimeline.durationSeconds': '{seconds}s',
  'supportChat.aiTimeline.durationMinutes': '{minutes}m',
  'supportChat.aiTimeline.durationMinutesSeconds': '{minutes}m {seconds}s',

  // Thread Participants
  'supportChat.participants.title': 'Thread Participants',
  'supportChat.participants.empty': 'No participants in this thread',
  'supportChat.participants.addSuccess': 'Participant added successfully',
  'supportChat.participants.addError': 'Error adding participant',
  'supportChat.participants.removeSuccess': 'Participant removed successfully',
  'supportChat.participants.removeError': 'Error removing participant',
  'supportChat.participants.updateSuccess': 'Permissions updated successfully',
  'supportChat.participants.updateError': 'Error updating permissions',
  'supportChat.participants.confirmRemove.title': 'Remove Participant',
  'supportChat.participants.confirmRemove.content':
    'Are you sure you want to remove {userName} from this thread?',
  'supportChat.participants.editAccess': 'Edit access permissions',
  'supportChat.participants.remove': 'Remove participant',
  'supportChat.participants.addedOn': 'Added on',

  // Access Modes
  'supportChat.participants.accessMode.label': 'Access',
  'supportChat.participants.accessMode.readonly': 'Read only',
  'supportChat.participants.accessMode.write': 'Write',
  'supportChat.participants.accessMode.readonlyDesc': 'Can view messages but cannot write',
  'supportChat.participants.accessMode.writeDesc': 'Can view and write messages',

  // Assignment Modes
  'supportChat.participants.assignmentMode.userInitiated': 'Added by user',
  'supportChat.participants.assignmentMode.adminAssigned': 'Assigned by admin',
  'supportChat.participants.assignmentMode.systemAssigned': 'Assigned by system',
  'supportChat.participants.assignmentMode.manualAssignment': 'Manual assignment',

  // Share Thread Modal
  'supportChat.share.title': 'Share Thread',
  'supportChat.share.description': 'Share this thread with other users to collaborate',
  'supportChat.share.selectUser': 'Select user',
  'supportChat.share.selectUsers': 'Select users',
  'supportChat.share.userRequired': 'You must select a user',
  'supportChat.share.usersRequired': 'You must select at least one user',
  'supportChat.share.userPlaceholder': 'Search user by name...',
  'supportChat.share.newParticipant': 'New participant',
  'supportChat.share.selectedUsers': 'Selected users',
  'supportChat.share.accessMode': 'Access type',
  'supportChat.share.selected': 'Selected',
  'supportChat.share.addParticipant': 'Add Participant',
  'supportChat.share.addParticipants': 'Add {count} Participants',
  'supportChat.participants.addMultipleSuccess': '{count} participants added successfully',
  'supportChat.participants.addMultipleError': 'Error adding {count} participants',
  'supportChat.participants.currentParticipants': 'Current Participants',
  'supportChat.participants.loading': 'Loading participants...',
  'supportChat.participants.noParticipants': 'No participants in this conversation',
  'supportChat.participants.unknownUser': 'Unknown user',
  'supportChat.participants.changeAccessSuccess': 'Access permissions updated successfully',
  'supportChat.participants.changeAccessError': 'Error updating access permissions',
  'supportChat.participants.removeSuccess': '{name} removed from conversation successfully',
  'supportChat.participants.removeError': 'Error removing {name} from conversation',
  'supportChat.participants.changeAccessTo': 'Change to {mode}',
  'supportChat.participants.remove': 'Remove from conversation',
  'supportChat.participants.accessShort': 'Access',
  'supportChat.participants.removeShort': 'Remove',
  'supportChat.participants.title': 'Participants',
  'supportChat.participants.defaultThreadTitle': 'Support Conversation',
  'supportChat.participants.drawerSubtitle': 'Manage access and collaborators',
  'supportChat.participants.addNew': 'Add Participants',

  // Conversation Actions
  'supportChat.threadActions.participants': 'View participants',
  'supportChat.threadActions.share': 'Share',
  'supportChat.takeConversation': 'Take conversation control',
  'supportChat.releaseConversation': 'Release conversation control',
  'supportChat.takeConversation.success': 'You now control this conversation',
  'supportChat.takeConversation.error': 'Could not take conversation control',
  'supportChat.releaseConversation.success': 'Conversation control returned to AI',
  'supportChat.releaseConversation.error': 'Could not release conversation control',
  'supportChat.tasks': 'Tasks',

  // Process Instance
  'supportChat.viewProcessInstance': 'View process instance',
  'supportChat.viewRequest': 'View request',

  // Search
  'supportChat.searchThreads': 'Search conversations...',
};
